<script lang="ts" setup>
import { ETitleBlockAligment, ETitleBlockSizes, type ITitleBlockProps } from './../ts/types'
import { isDark } from '@/ui/helpers/utils'

const props = withDefaults(defineProps<ITitleBlockProps>(), {
    headingBlockAligment: ETitleBlockAligment.LEFT,
})
</script>

<template>
    <div
        class="gap-base col-span-full flex flex-col text-left lg:col-span-8"
        :class="[
            {
                'md:items-center md:text-center lg:col-start-3':
                    props.headingBlockAligment === ETitleBlockAligment.CENTER,
                'gap-base': props.headingBlockSize === ETitleBlockSizes.H1,
                'gap-sm': props.headingBlockSize !== ETitleBlockSizes.H1,
            },
            isDark(props.dark),
        ]"
    >
        <div
            v-if="props.badges?.length"
            class="gap-xs flex"
        >
            <VBadge
                v-for="(badge, index) in props.badges?.slice(0, 2)"
                :key="`badge_${index}`"
                :data-test="`badge_${index}`"
                :variant="badge.visualVariant"
                size="SMALL"
                :icon="badge.icon"
                :dark="props.dark"
            >
                {{ badge.label }}
            </VBadge>
        </div>

        <TitleBlockPartsHeading
            v-if="props.heading"
            :heading-block-size="props.headingBlockSize"
            :seo-heading-size="props.seoHeadingSize"
            :text="props.heading"
            class="title-block__heading"
        />

        <TitleBlockPartsSubheading
            v-if="props.subheading"
            :heading-block-size="props.headingBlockSize"
            :text="props.subheading"
            class="title-block__subheading"
        />

        <TitleBlockPartsParagraph
            v-if="props.paragraph"
            :text="props.paragraph"
            class="title-block__paragraph"
        />
    </div>
</template>
